import { Layout } from "components/Layout";
import { generateDefaultSeo } from "next-seo/pages";
import type { AppProps } from "next/app";
import { Figtree } from "next/font/google";
import Head from "next/head";
import "../styles/globals.css";

const figtree = Figtree({
  subsets: ["latin"],
  display: "swap",
});

function MyApp({ Component, pageProps }: AppProps) {
  return (
    <>
      <Head>
        {generateDefaultSeo({
          title: "irisarco's art",
          description: "irisarco's art site",
          openGraph: {
            type: "website",
            locale: "en_US",
            images: [{ url: process.env.NEXT_PUBLIC_URL + "/banner.jpg" }],
            site_name: "irisarco's art",
          },
          twitter: { cardType: "summary_large_image" },
        })}
      </Head>
      <Layout className={figtree.className}>
        <Component {...pageProps} />
      </Layout>
    </>
  );
}

export default MyApp;
